import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import makeStyles from './../makeStyles/makeStylesInternal';
var useStyles = makeStyles(function () {
  return {
    root: {}
  };
});

/**
 * A container for tab content.
 */
var TabLayoutContent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var classes = useStyles();
  var children = props.children,
    className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(className, classes.root),
    ref: ref
  }), children);
});
TabLayoutContent.muiName = 'TabLayoutContent';
TabLayoutContent.displayName = 'TabLayoutContent';
TabLayoutContent.propTypes = {
  /**
   * A CSS class that will be applied to the parent `div`.
   */
  className: PropTypes.string,
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object
};
export default TabLayoutContent;